import DOMPurify from 'dompurify';
import { useComponentEntry } from '@utils/component-framework';
import '@i-ark/models';
import 'react';
import '@tanstack/react-query';
import { selectTableCellEntryById } from '../../../state/selectors/entry.table-cell-by-id.js';
import { iArkStore } from '../../../state/store.js';
import { inputCls } from './TableCellInputReadonly.style.js';
import { jsx } from 'react/jsx-runtime';

// eslint-disable-next-line import-x/no-named-as-default
const TableCellInputReadonly = ({
  pageId,
  itemId,
  cell
}) => {
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const cellEntry = useComponentEntry(entryKey, {
    select: selectTableCellEntryById(pageId, itemId, cell.id)
  });
  return /*#__PURE__*/jsx("span", {
    className: inputCls,
    children: /*#__PURE__*/jsx("span", {
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize(cellEntry.data ?? "", {
          USE_PROFILES: {
            html: true
          }
        })
      }
    })
  });
};

export { TableCellInputReadonly };
//# sourceMappingURL=TableCellInputReadonly.js.map
